import React, { useState } from 'react';

import Select from '@shadcn/components/ui/react-select.jsx';
import useQuery from '../../helpers/JIFI/useQuery';

// Typeahead that searches containers by supplier/container ref and returns the
// selected container _id via onChange. Server-side search via /inventory/fetchContainer.
const ContainerSelect = ({ value, onChange, placeholder = 'Search container ref…' }) => {
  const [term, setTerm] = useState('');
  const [selected, setSelected] = useState(null);

  const [result, state] = useQuery({
    url: `/inventory/fetchContainer`,
    queryData: { searchTerm: term, perPage: 20 },
  });

  const containers = result?.replenishObject ?? [];
  const options = containers.map((c) => ({
    value: c._id,
    label: c.ref ? `${c.name} · ${c.ref}` : c.name,
  }));

  // Keep showing the chosen label even after the search term/options change.
  const current = selected && selected.value === value ? selected : null;

  return (
    <Select
      isClearable
      placeholder={placeholder}
      options={options}
      value={current}
      isLoading={state === 'loading'}
      filterOption={null} // server already filtered — don't re-filter client-side
      onInputChange={(v, meta) => {
        if (meta.action === 'input-change') setTerm(v);
      }}
      onChange={(opt) => {
        setSelected(opt);
        onChange(opt ? opt.value : '');
      }}
      noOptionsMessage={() => (term ? 'No matching containers' : 'Type to search…')}
    />
  );
};

export default ContainerSelect;
